import { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/service/utils/cn';

type TRadioInputProps = InputHTMLAttributes<HTMLInputElement> & {
    label: string | ReactNode;
    className?: string;
};

export const RadioInput = ({ className, label, ...inputProps }: TRadioInputProps) => (
    <label
        className={cn('flex w-full max-w-max cursor-pointer items-center gap-[15px]', className)}
    >
        <input className="hidden" type="radio" {...inputProps} />
        {label}
    </label>
);
